import { render, staticRenderFns } from "./AboutMenu.vue?vue&type=template&id=08b3aa46&"
import script from "./aboutMenu.js?vue&type=script&lang=js&"
export * from "./aboutMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports